module.exports = __webpack_public_path__ + "static/media/email-send.2fcbb997.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/email-send.svg
// module id = 635
// module chunks = 0 1